import TKFormValidator, { Validation } from '@tk/controls/tk.form.validator';
import { formErrorMessages } from '@tk/utilities/tk.messages';

export default class DIWFormValidator extends TKFormValidator {
    validateField(item: Validation) {
        this.removeMessage(item);

        // Always check email fields first to properly clear/set custom validity
        if (item.element instanceof HTMLInputElement && item.element.type.toLowerCase() === 'email') {
            this.validateEmailField(item);
            return;
        }

        if (!item.element.validity.valid) {
            this.showMessage(item);
        }
    }

    private validateEmailField(item: Validation) {
        const element = item.element;

        if (!(element instanceof HTMLInputElement) || element.type.toLowerCase() !== 'email') return;

        const value = element.value.trim();
        if (value === '') {
            element.setCustomValidity('');
            return;
        }

        const atIndex = value.indexOf('@');
        const dotIndex = value.lastIndexOf('.');
        const hasValidFormat = atIndex > 0 && dotIndex > atIndex + 1 && dotIndex < value.length - 1;

        if (hasValidFormat) {
            element.setCustomValidity('');
            return;
        }

        const customTypeMismatchMessage = element.getAttribute('data-tk-error-msg-type-mismatch') || '';
        const fallbackMessage = formErrorMessages.typeMismatch || element.validationMessage;
        const message = customTypeMismatchMessage || fallbackMessage;
        element.setCustomValidity(message);
        this.createElementMessage(item, message);
    }
}
